<script setup lang="ts">
import type { PropType } from 'vue'
import BaseIcon from '@/components/ui/icon/BaseIcon.vue'

export interface ExcludedCoverageContent {
	title: string
	footerNote: string
	cards: {
		title: string
		listItems: string[]
	}[]
}

defineProps({
	content: {
		type: Object as PropType<ExcludedCoverageContent>,
		required: true,
	},
})

const icons = ['vase', 'thundercloud', 'forbid_package']
</script>

<template>
	<section class="bs-container py-distant-acquaintances text-n-950">
		<div class="col-span-12">
			<div class="typography-h2-str text-center">
				{{ content.title }}
			</div>

			<div class="my-acquaintances flex flex-col gap-20px mdp:flex-row">
				<div
					v-for="(card, index) in content.cards"
					:key="card.title"
					class="flex flex-1 flex-col gap-close-ish-friends rounded-[16px] bg-n-25 p-good-friends"
				>
					<BaseIcon
						:name="icons[index]"
						class="h-[64px] w-[64px] flex-shrink-0"
					/>

					<div class="typography-h5-str">
						{{ card.title }}
					</div>

					<ul class="flex list-none flex-col gap-strong-friends">
						<li
							v-for="item in card.listItems"
							:key="item"
							class="flex items-center gap-best-friends rounded-[12px] bg-n-50 px-16px py-12px"
						>
							<BaseIcon name="close_v1" class="h-16px w-16px flex-shrink-0" />
							<span class="typography-s1-reg [&_a]:text-o-500" v-html="item" />
						</li>
					</ul>
				</div>
			</div>

			<div
				v-if="content.footerNote"
				class="typography-s2-reg text-center text-n-500 [&_a]:text-o-500"
				v-html="content.footerNote"
			/>
		</div>
	</section>
</template>
